import { useInvoiceStore } from "../store/invoice-store";
import { Modal } from "@renderbus/ui/components/modal";
import { Button } from "@renderbus/ui";
import { useTranslation } from "react-i18next";
import Warning from "@/assets/icons/common/warning";
import dayjs from "dayjs";
import styled from "styled-components";

const TipContent = styled.div`
  display: flex;
  gap: 10px;
  svg {
    width: 60px;
  }
`;

export function InvoiceCompanyModal() {
  const { t } = useTranslation("invoice");
  const { t: commonT } = useTranslation("common");
  const { openCompanyChangeModal, setOpenCompanyChangeModal, tipDate } =
    useInvoiceStore();

  return (
    <Modal
      width={600}
      title={t("invoice_tip_title")}
      open={openCompanyChangeModal}
      children={
        <TipContent>
          <Warning />
          {t("invoice_compang_change_tip", {
            time: dayjs(tipDate).format("YYYY-MM-DD HH:mm:ss"),
          })}
        </TipContent>
      }
      onCancel={() => setOpenCompanyChangeModal(false)}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={() => setOpenCompanyChangeModal(false)}
        >
          {commonT("common_sure")}
        </Button>,
      ]}
    />
  );
}
